import { environment } from './../../../../../environment/environment';
import { serverError } from './../../../../core/models/messages';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Country } from 'country-state-city';
import { translations } from '../../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { EvaluationService } from '@core/services/evaluation/evaluation.service';
import { Subject, takeUntil } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LocalStorageService } from '@core/services/local-storage.service';

export enum StatusEnum {
  Envoye = '1',
  Rempli = '2',
  Recu = '3'
}

@Component({
  selector: 'app-esn-evaluation-sent',
  templateUrl: './esn-evaluation-sent.component.html',
  styleUrls: ['./esn-evaluation-sent.component.css'],
})

export class EsnEvaluationSentComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  private unsubscribeAll: Subject<void> = new Subject();

  startIndex: number = 0;
  skills: any = [];
  name: any = [];

  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  url: string = environment.baseUrl + '/api';
  // urlImage: string = environment.baseUrlGalery;
  urlImage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;

  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();

  // Créez un objet pour stocker les états des cases à cocher
  checkboxStates: { [key: string]: boolean } = {};
  check: any = [];

  isCollapsed = true;
  statusEnum = StatusEnum;

  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  compt = [
    { id: 1, name: 'Immédiate' },
    { id: 2, name: '2 mois' },
    { id: 3, name: '3 mois' },
    { id: 4, name: '4 mois' },
    { id: 5, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'CDI' },
    { id: 2, name: 'CDD' },
    { id: 3, name: 'SIVP' },
    { id: 4, name: 'Freelance' },
    { id: 5, name: 'autres' },
  ];
  poste = [
    { id: 1, name: 'Hybrid' },
    { id: 2, name: 'à distance' },
    { id: 3, name: 'télétravail' },
  ];

  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  typeList = [
    { id: 'Annuelle', name: 'Annuelle' },
    { id: 'Suivi', name: 'Suivi' },
  ];

  statusList = [
    { id: 1, name: 'Envoyée' },
    { id: 3, name: 'Reçue' },
  ];

  pageSizeOptions = [5, 10, 20];
  pageSize = 5;
  currentPage = 0;
  totalElements = 0
  templatesListESN: any;

  modalRef?: BsModalRef;
  safeDescription!: SafeHtml;
  currentUser: any;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private evaluationService : EvaluationService,
    private router: Router,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
  ) {

    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  ngOnInit() {
    this.currentUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}');
    this.getTemplateListEsn();
  }

  reset() {
    this.searchForm.reset();
    this.currentPage = 0
    this.getTemplateListEsn();
  }

  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name_eval: [null, data?.name_eval],
      type_eval: [null, data?.type_eval],
      name_consultant: [null, data?.name_consultant],
      start_date: [null, data?.start_date],
      end_date: [null, data?.end_date],
      status_eval: [null, data?.status_eval],
    });
  }

  getTemplateListEsn(){
      this.spinner.show();
  
      let startDate = this.searchForm.get('start_date')?.value
      if(startDate){
        startDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
      }

      let endDate = this.searchForm.get('end_date')?.value
      if(endDate){
        endDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');
      }
      const params = {
        per_page: this.pageSize,
        page: this.currentPage,
        name_eval: this.searchForm.get('name_eval')?.value,
        type_eval: this.searchForm.get('type_eval')?.value,
        status_eval: this.searchForm.get('status_eval')?.value,
        name_consultant: this.searchForm.get('name_consultant')?.value,
        start_date: startDate,
        end_date: endDate
      }
      this.evaluationService
          .fetchSentTemplates(params)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {
              if (res.status == 200) {
                this.templatesListESN = res.data?.data
                this.totalElements = res.data?.total
                this.spinner.hide();
              }
            },
            error: (err) => {
              this.spinner.hide();
              if (err?.error) {
                this.toastrService.error(serverError);
              }
            },
          });
  }
  
    /**
       * Handle page change event from the paginator.
       * @param event The page event containing the new page index and page size.
       */
  onPageChange(e: PageEvent): void {
          this.pageSize = e.pageSize;
          this.currentPage = e.pageIndex;
          this.getTemplateListEsn()
  }

  getStatusLabel(status: StatusEnum): string {
    return status === StatusEnum.Recu ? 'Reçue' : 'Envoyée';
  }

  isSendEnable(evaluation : any) : boolean{
    return evaluation?.eval_pv_esn?.length > 0
  }

  sendPV(evaluation : any){    
    this.spinner.show();
    this.evaluationService
      .sendPv(evaluation?.eval_pv_esn[0]?.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.currentPage = 0
            this.getTemplateListEsn()
            this.toastrService.success("Le compte rendu a été envoyé avec succès.");
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            this.toastrService.error(serverError);
          }
        },
      });
}

  openModalReport(template: TemplateRef<any>, evaluation: any) {
      this.modalRef = this.modalService.show(template);
      const rawHtml = evaluation?.eval_pv_esn[0]?.report || '';
      this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }
  closeModal() {
      this.modalRef?.hide();
  }

  isEvalOwner(evaluation : any) : boolean{   
    return this.currentUser?.id === evaluation?.sender?.id
  }

  getDateByStatus(evaluation: any): string {
    return evaluation?.status === '3'
      ? evaluation.sent_at_by_consultant
      : evaluation.sent_at;
  }

  getDateTooltip(evaluation: any): string {
    return evaluation?.status === '3'
      ? "Date de réception"
      : "Date d'envoi";
  }
}
